import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-premium";
import { Box, Typography, Divider, Button, Chip } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";
import { PaymentFilter } from "../../types/payment";

type Props = {
  title: string;
  total: number;
  selectedCount: number;
  onGenerateFile: () => void;
  statusFilter: PaymentFilter;
  onStatusFilterChange: (status: PaymentFilter) => void;
};

export default function PaymentsToolbar({
  title,
  total,
  selectedCount,
  onGenerateFile,
  statusFilter,
  onStatusFilterChange,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <GridToolbarContainer sx={{ px: 2, py: 1.5 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          {t("Łącznie")}: {total}
          {selectedCount > 0 && ` • ${t("Zaznaczone")}: ${selectedCount}`}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Chip
          label={t("Do zapłaty")}
          clickable
          color={statusFilter === "TO_PAY" ? "primary" : "default"}
          variant={statusFilter === "TO_PAY" ? "filled" : "outlined"}
          onClick={() => onStatusFilterChange("TO_PAY")}
        />

        <Chip
          label={t("Wszystkie")}
          clickable
          color={statusFilter === "ALL" ? "primary" : "default"}
          variant={statusFilter === "ALL" ? "filled" : "outlined"}
          onClick={() => onStatusFilterChange("ALL")}
        />

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <Button
          size="small"
          variant="contained"
          disabled={selectedCount === 0}
          onClick={onGenerateFile}
        >
          {t("Generuj plik bankowy")}
        </Button>

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </Box>
    </GridToolbarContainer>
  );
}